import { render } from "./InvoicesManager.vue?vue&type=template&id=cbf98dca&scoped=true"
import script from "./InvoicesManager.vue?vue&type=script&lang=js"
export * from "./InvoicesManager.vue?vue&type=script&lang=js"

import "./InvoicesManager.vue?vue&type=style&index=0&id=cbf98dca&lang=scss&scoped=true"
import "./InvoicesManager.vue?vue&type=style&index=1&id=cbf98dca&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf98dca"]])

export default __exports__